const filesHaveDirectories = (files: { fullpath?: string }[]): boolean =>
  files.some((file) => {
    const fullpath = file.fullpath ?? '';
    // first char of fullpath is always a slash so more than 2 splits
    // mean that there's a subdirectory
    return fullpath.split('/').length > 2;
  });

export default filesHaveDirectories;
